/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';
import { notebookss } from './notebookss';

export class notebookitem extends IceEntity {
  notebook_item_key: string = "";

  SSITEMS: notebookss[] = [];

  constructor(attr: any = {}) {
    super();
    for (let colName of Object.keys(attr)) {
      if (attr[colName] == null) continue;
      this.attributes[colName] = attr[colName];
    }
  }

  public gettablename(): string {
    return "NOTEBOOK_ITEM";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "SSITEMS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "SSITEMS") return "NBSS";

    return null;
  }
}
